export default __webpack_public_path__ + "static/media/DriverMarker.4c2c8726.svg";